(ns frontend.view.entity-viewers.activity.insider-activity
  (:require
   [clojure.string :as string]
   [common.entity :as entity]
   [common.localization :as loc]
   [frontend.state.current-session :as session]))

(defn popup-view
  [insider-group-id]
  (let [insider-group (session/get-entity insider-group-id)]
    [:div
     {:class "mb-0 flex flex-col gap-3 text-sm text-base-light-text"}
     [:div 
      {:class "flex flex-col gap-1"}
      [:label
       {:class "text-base-light-text-paler"}
       (loc/tr :insider-group-name)]
      [:div
       {:class "font-semibold"}
       (:insider-group/name insider-group)]]
     [:div 
      {:class "flex flex-col gap-1"}
      [:label
       {:class "text-base-light-text-paler"}
       (loc/tr :visible-for-these-accounts)]
      [:div
       {:class "font-semibold"}
       (->> insider-group
            :insider-group/members
            (keep session/get-entity)
            (map entity/display-string)
            (string/join ", "))]]
     (->> insider-group
          :insider-group/teams
          (keep session/get-entity)
          (map (fn [team]
                 [:<>
                  [:div 
                   {:class "flex flex-col gap-1"}
                   [:label
                    {:class "text-base-light-text-paler"}
                    (loc/tr :also-all-team-members [(:team/name team)])]
                   [:div
                    {:class "font-semibold"}
                    (->> team
                         :team/members
                         (keep session/get-entity)
                         (map entity/display-string)
                         (string/join ", "))]]]))
          (doall))
     [:div 
      {:class "flex flex-col gap-1"}
      [:label
       {:class "text-base-light-text-paler"}
       (loc/tr :and-all-administrators)]
      [:div
       {:class "font-semibold"}
       (->> @session/all-roles
            (filter (fn [r]
                      (= :role/admin (:role/role r))))
            (map :role/subject)
            (map session/get-entity)
            (map entity/display-string)
            (string/join ", "))]]]))
